export default __webpack_public_path__ + "static/media/center1.dc4ddd3c.jpg";